<template>
  <div class="404">
    <van-empty description="您已迷路！">
      <van-button to="/" round type="danger" class="bottom-button">
        返回首页
      </van-button>
    </van-empty>
  </div>
</template>

<script>
export default {

}
</script>

<style>
  .bottom-button {
    width: 160px;
    height: 40px;
  }
</style>